import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, isRef as _isRef, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import {
  computed, onBeforeMount, ref, defineAsyncComponent,
} from 'vue';
import AppHeader from '~components/AppHeader.vue';
import ModalContainer from '~components/modals/ModalContainer.vue';
import { getCookie } from '~utils/cookies';
import { UserData } from '@/store/auth/types';
import { useMainStore } from '@/store';
import { useAuthStore } from '@/store/auth/authModule';
import { useOrgsStore } from '@/store/orgs/orgsModule';
import { storeToRefs } from 'pinia';
import { modalComponentsMap } from '~components/modals/modalMap';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let AUTH_HOST = window.location.origin;
if (AUTH_HOST.indexOf('localhost') !== -1) {
  AUTH_HOST = 'http://localhost:8081';
}

const authStore = useAuthStore();

const isLoading = ref(false);

const { isAuth } = storeToRefs(authStore);

const authInProcess = ref(false);

const notAutorizedText = computed(() => 'Вы не авторизованы в системе'.toUpperCase());

const checkAuth = () => {
  const storedUserData: UserData = {
    id_login: getCookie('id_login') || '',
    TK: getCookie('TK') || '',
  };
  if (storedUserData.id_login && storedUserData.TK) {
    return storedUserData;
  }
  return false;
};

const autenticate = async () => {
  authInProcess.value = true;
  const storedUserData = checkAuth();
  if (storedUserData) {
    await authStore.autenticate(storedUserData);
  }
  authInProcess.value = false;
};

const openLoginPopup = () => {
  const receiveMessage = (event: MessageEvent) => {
    if (event.data === 'login') {
      autenticate();
    }
  };
  const windowFeatures = 'popup, scrollbars=yes, resizable=yes, toolbar=1 menubar=yes';
  const authWindow = window.open(`${AUTH_HOST}/login`, 'Auth', windowFeatures);
  if (authWindow) {
    window.addEventListener('message', receiveMessage);
  }
};

onBeforeMount(async () => {
  isLoading.value = true;
  await autenticate();
  isLoading.value = false;
});

const {
  modal, modalComponent, message, messageContent,
} = storeToRefs(useMainStore());

const modalComponentName = computed(() => {
  console.log(modalComponent.value.name);
  try {
    const component = defineAsyncComponent(() => import(`~components/modals/${modalComponent.value.name}.vue`));
    return component;
  } catch (error: string) {
    throw new Error(error);
  }
});
const modalComponentParams = computed(() => modalComponent.value.params);
const modalComponentHeader = computed(() => modalComponentsMap[modalComponent.value.name]?.header);

const closeModal = () => {
  useMainStore().closeModal();
};


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_spinner_pie = _resolveComponent("q-spinner-pie")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_layout, { view: "lHh Lpr lFf" }, {
      default: _withCtx(() => [
        _createVNode(AppHeader),
        (!authInProcess.value)
          ? (_openBlock(), _createBlock(_component_q_page_container, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_q_inner_loading, { showing: isLoading.value }, {
          default: _withCtx(() => [
            _createVNode(_component_q_spinner_pie, {
              size: "50px",
              color: "accent"
            })
          ]),
          _: 1
        }, 8, ["showing"]),
        _createVNode(_component_q_dialog, {
          modelValue: _unref(modal),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modal) ? (modal).value = $event : null))
        }, {
          default: _withCtx(() => [
            _createVNode(ModalContainer, {
              header: _unref(modalComponentHeader),
              onClose: closeModal
            }, {
              content: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(modalComponentName)), { params: _unref(modalComponentParams) }, null, 8, ["params"]))
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_q_dialog, {
          modelValue: _unref(message),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(message) ? (message).value = $event : null)),
          seamless: "",
          position: "bottom"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, { style: {"width":"350px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, { class: "row items-center no-wrap" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(messageContent)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (authInProcess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_inner_loading, {
            showing: true,
            label: "Идет авторизация..."
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_spinner_pie, {
                size: "50px",
                color: "accent"
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})